<template>
  <div class="w-full">
    <div class="flex items-center justify-center gap-2 cursor-pointer select-none hover:opacity-80 transition-opacity" :class="{ 'mb-6': showBreakdown }" @click="showBreakdown = !showBreakdown">
      <h2 class="text-2xl font-semibold text-center whitespace-nowrap">
        <span :class="['breakdown_show_text', { breakdown_show_text_hidden: showBreakdown }]">Show</span>
        AI Credit Consumption Breakdown
      </h2>
      <span :class="['breakdown_chevron', { breakdown_chevron_open: showBreakdown }]">&#9662;</span>
    </div>
    <Transition name="breakdown-slide">
      <div v-if="showBreakdown" class="v4_table rounded-xl overflow-hidden">
        <table class="w-full text-sm">
          <thead>
            <tr class="v4_table_header">
              <th class="text-left px-5 py-3 font-semibold">ACTION</th>
              <th class="text-left px-5 py-3 font-semibold">CREDITS CONSUMED</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in creditConsumptionData" :key="index" class="v4_table_row">
              <td class="px-5 py-3">
                <div class="flex items-center gap-1.5">
                  {{ item.action }}
                  <a-tooltip v-if="item.tooltip" :title="item.tooltip" placement="right">
                    <img :src="imagePath.infoIcon" alt="info" class="cursor-pointer w-4 h-4" />
                  </a-tooltip>
                </div>
              </td>
              <td class="px-5 py-3 v4_secondary_text">
                <span v-if="item.link">
                  <a :href="item.link" target="_blank" rel="noopener noreferrer" class="font-semibold underline hover:opacity-80">{{ item.credits }}</a>
                </span>
                <span v-else>{{ item.credits }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </Transition>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import imagePath from '@/javascript/imagePath';
import { creditConsumptionData } from '@/constants/billingConstants';

const showBreakdown = ref(false);
</script>

<style scoped>
.v4_table {
  border: 1px solid #00000014;
}

.v4_table_header {
  background-color: #0000000a;
  color: #000;
}

.v4_table_row {
  border-top: 1px solid #00000014;
  color: #000;
}

.v4_secondary_text {
  color: #666666;
}

.breakdown_chevron {
  display: inline-block;
  transition: transform 0.3s ease;
  font-size: 16px;
  color: #666666;
}

.breakdown_chevron_open {
  transform: rotate(180deg);
}

.breakdown-slide-enter-active {
  transition: all 0.3s ease;
}

.breakdown-slide-leave-active {
  transition: all 0.25s ease;
}

.breakdown-slide-enter-from,
.breakdown-slide-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

.breakdown_show_text {
  display: inline-block;
  overflow: hidden;
  vertical-align: bottom;
  max-width: 80px;
  opacity: 1;
  transition:
    max-width 0.3s ease,
    opacity 0.25s ease;
}

.breakdown_show_text_hidden {
  max-width: 0;
  opacity: 0;
}
</style>
